
        import * as module0 from './controllers/nav_controller.js';import * as module1 from './controllers/site_controller.js';import * as module2 from './controllers/slideshow_controller.js'
        const modules = {
            "./controllers/nav_controller.js": module0,
            "./controllers/site_controller.js": module1,
            "./controllers/slideshow_controller.js": module2,
        };
        export default modules;
      